import React from 'react'
import { Container } from 'react-bootstrap'
import ContactsForm from './components/ContactsForm'
import Questions from'./components/Questions'
import { Navbar  } from 'react-bootstrap'

function App() {
  return (
    <Container className="justify-content-center">
      <Navbar bg="light" variant="light" className="mb-5 mt-5">
          <Navbar.Brand href="#home">Contact Form</Navbar.Brand>                
      </Navbar>
      <ContactsForm />
      <Questions/>
   </Container>
  );
}

export default App;
